import React from 'react';
// import axios from 'axios';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import KavuMainPage from './kavumainpage/KavuMainPage';
import CombinedDashboard from './gallarycomponents/CombinedDashboard';
 
// import Socialmediapage from './gallarycomponents/socialmediapage'; // Import the social media page
// import PrivacyPolicy from './gallarycomponents/PrivacyPolicy.jsx';
// import TermsAndConditions from './gallarycomponents/TermsAndConditions.jsx';
// import PostCreationForm from './gallarycomponents/PostCreationForm.jsx';
import './App.css'
// axios.defaults.withCredentials = true;
// axios.defaults.baseURL = 'http://localhost:8000';

function App() {
  return (
    <Router>
      <Routes>
          <Route path="/" element={<KavuMainPage />} />
          
        <Route path="/gallery" element={<CombinedDashboard />} />
     
      
        {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/uploadimage" element={<PostCreationForm />} /> */}
         
      </Routes>
    </Router>
  );
}

export default App;